// --- Light Mode Image Imports ---
import Four_Chamber_View_of_the_Heart from '../assets/iconsPlans/Four_Chamber_View_of_the_Heart.png';
import LVOT from '../assets/iconsPlans/LVOT.png';
import RVOT from '../assets/iconsPlans/RVOT.png';
import Three_Vessel_View from '../assets/iconsPlans/Three_Vessel_View.png';
import Three_Vessel_View_Trachea from '../assets/iconsPlans/Three_Vessel_View_Trachea.png';
import Transventricular_View from '../assets/iconsPlans/Transventricular_View.png';
import Transthalamic_View from '../assets/iconsPlans/Transthalamic_View.png';
import Transcerebellar_View from '../assets/iconsPlans/Transcerebellar_View.png';
import Sagittal_View_of_the_Brain from '../assets/iconsPlans/Sagittal_View_of_the_Brain.png';
import Sagittal_View_of_the_Face from '../assets/iconsPlans/Sagittal_View_of_the_Face.png';
import Coronal_View_of_Upper_Lip_Nose_Nostrils from '../assets/iconsPlans/Coronal_View_of_Upper_Lip_Nose_Nostrils.png';
import Sagittal_View_of_the_Entire_Spine from '../assets/iconsPlans/Sagittal_View_of_the_Entire_Spine.png';
import Coronal_View_of_the_Spine from '../assets/iconsPlans/Coronal_View_of_the_Spine.png';
import Fetal_Abdominal_Standard_Plane from '../assets/iconsPlans/Fetal_Abdominal_Standard_Plane.png';
import Axial_View_of_Kidneys from '../assets/iconsPlans/Axial_View_of_Kidneys.png';
import Axial_View_of_Fetal_Bladder from '../assets/iconsPlans/Axial_View_of_Fetal_Bladder.png';
import View_of_Upper_Limb from '../assets/iconsPlans/View_of_Upper_Limb.png';
import View_of_Lower_Limb from '../assets/iconsPlans/View_of_Lower_Limb.png';
import Femur_Plane from '../assets/iconsPlans/Femur_Plane.png';
import View_of_Genitalia from '../assets/iconsPlans/View_of_Genitalia.png';
import Sagittal_View_of_Cervix_with_Placenta from '../assets/iconsPlans/Sagittal_View_of_Cervix_with_Placenta.png';
import Sagittal_View_for_CRL_and_NC_Measurements from '../assets/iconsPlans/Sagittal_View_for_CRL_and_NC_Measurements.png';

// --- Dark Mode Image Imports (assuming filenames end with _dark) ---
import Four_Chamber_View_of_the_Heart_dark from '../assets/iconsPlans/Four_Chamber_View_of_the_Heart_dark.png';
import LVOT_dark from '../assets/iconsPlans/LVOT_dark.png';
import RVOT_dark from '../assets/iconsPlans/RVOT_dark.png';
import Three_Vessel_View_dark from '../assets/iconsPlans/Three_Vessel_View_dark.png';
import Three_Vessel_View_Trachea_dark from '../assets/iconsPlans/Three_Vessel_View_Trachea_dark.png';
import Transventricular_View_dark from '../assets/iconsPlans/Transventricular_View_dark.png';
import Transthalamic_View_dark from '../assets/iconsPlans/Transthalamic_View_dark.png';
import Transcerebellar_View_dark from '../assets/iconsPlans/Transcerebellar_View_dark.png';
import Sagittal_View_of_the_Brain_dark from '../assets/iconsPlans/Sagittal_View_of_the_Brain_dark.png';
import Sagittal_View_of_the_Face_dark from '../assets/iconsPlans/Sagittal_View_of_the_Face_dark.png';
import Coronal_View_of_Upper_Lip_Nose_Nostrils_dark from '../assets/iconsPlans/Coronal_View_of_Upper_Lip_Nose_Nostrils_dark.png';
import Sagittal_View_of_the_Entire_Spine_dark from '../assets/iconsPlans/Sagittal_View_of_the_Entire_Spine_dark.png';
import Coronal_View_of_the_Spine_dark from '../assets/iconsPlans/Coronal_View_of_the_Spine_dark.png';
import Fetal_Abdominal_Standard_Plane_dark from '../assets/iconsPlans/Fetal_Abdominal_Standard_Plane_dark.png';
import Axial_View_of_Kidneys_dark from '../assets/iconsPlans/Axial_View_of_Kidneys_dark.png';
import Axial_View_of_Fetal_Bladder_dark from '../assets/iconsPlans/Axial_View_of_Fetal_Bladder_dark.png';
import View_of_Upper_Limb_dark from '../assets/iconsPlans/View_of_Upper_Limb_dark.png';
import View_of_Lower_Limb_dark from '../assets/iconsPlans/View_of_Lower_Limb_dark.png';
import Femur_Plane_dark from '../assets/iconsPlans/Femur_Plane_dark.png';
import View_of_Genitalia_dark from '../assets/iconsPlans/View_of_Genitalia_dark.png';
import Sagittal_View_of_Cervix_with_Placenta_dark from '../assets/iconsPlans/Sagittal_View_of_Cervix_with_Placenta_dark.png';
import Sagittal_View_for_CRL_and_NC_Measurements_dark from '../assets/iconsPlans/Sagittal_View_for_CRL_and_NC_Measurements_dark.png';
import afpocket from '../assets/iconsPlans/afpocket.png';
import afpocket_dark from '../assets/iconsPlans/afpocket_dark.png';

import Orbits_View_dark from '../assets/iconsPlans/orbits_dark.png';
import Orbits_View from '../assets/iconsPlans/orbits.png';

export const PLANES_CONFIGS = {
  // Cardiac Views
  VIEW__4CH: {
    image: Four_Chamber_View_of_the_Heart,
    darkImage: Four_Chamber_View_of_the_Heart_dark,
    displayName: 'Four Chamber View of the Heart',
    group: 'CARDIAC',
    family: 'Heart Structure',
  },
  VIEW__RVOT: {
    image: RVOT,
    darkImage: RVOT_dark,
    displayName: 'Right Ventricular Outflow Tract',
    group: 'CARDIAC',
    family: 'Heart Outflow',
  },
  VIEW__LVOT: {
    image: LVOT,
    darkImage: LVOT_dark,
    displayName: 'Left Ventricular Outflow Tract',
    group: 'CARDIAC',
    family: 'Heart Outflow',
  },
  VIEW__ThreeVesselView: {
    image: Three_Vessel_View,
    darkImage: Three_Vessel_View_dark,
    displayName: 'Three Vessel View',
    group: 'CARDIAC',
    family: 'Great Vessels',
  },

  // Fetal Head and Brain Views
  VIEW__Transthalamic: {
    image: Transthalamic_View,
    darkImage: Transthalamic_View_dark,
    displayName: 'Transthalamic View',
    group: 'FETAL_HEAD_BRAIN',
    family: 'Brain Structure',
  },
  VIEW__Transventricular: {
    image: Transventricular_View,
    darkImage: Transventricular_View_dark,
    displayName: 'Transventricular View',
    group: 'FETAL_HEAD_BRAIN',
    family: 'Brain Structure',
  },
  VIEW__Transcerebellar: {
    image: Transcerebellar_View,
    darkImage: Transcerebellar_View_dark,
    displayName: 'Transcerebellar View',
    group: 'FETAL_HEAD_BRAIN',
    family: 'Brain Structure',
  },

  // Spinal Views
  // VIEW__SagittalViewOfTheEntireSpine: {
  //   image: Sagittal_View_of_the_Entire_Spine,
  //   darkImage: Sagittal_View_of_the_Entire_Spine_dark,
  //   displayName: 'Sagittal View of the Entire Spine',
  //   group: 'SPINAL',
  //   family: 'Spine Structure',
  // },

  // Abdominal and Genitalia Views
  VIEW__FetalAbdominalStandardPlane: {
    image: Fetal_Abdominal_Standard_Plane,
    darkImage: Fetal_Abdominal_Standard_Plane_dark,
    displayName: 'Fetal Abdominal Standard Plane',
    group: 'ABDOMINAL_GENITALIA',
    family: 'Abdomen',
  },
  VIEW__AxialViewOfFetalBladder: {
    image: Axial_View_of_Fetal_Bladder,
    darkImage: Axial_View_of_Fetal_Bladder_dark,
    displayName: 'Axial View of Fetal Bladder',
    group: 'ABDOMINAL_GENITALIA',
    family: 'Urogenital',
  },
  VIEW__AxialViewOfKidneys: {
    image: Axial_View_of_Kidneys,
    darkImage: Axial_View_of_Kidneys_dark,
    displayName: 'Axial View of Kidneys',
    group: 'ABDOMINAL_GENITALIA',
    family: 'Urogenital',
  },
  VIEW__Genitalia: {
    image: View_of_Genitalia,
    darkImage: View_of_Genitalia_dark,
    displayName: 'View of Genitalia',
    group: 'ABDOMINAL_GENITALIA',
    family: 'Urogenital',
  },

  // Limb Views
  VIEW__LowerLimb: {
    image: View_of_Lower_Limb,
    darkImage: View_of_Lower_Limb_dark,
    displayName: 'View of Lower Limb',
    group: 'LIMB',
    family: 'Lower Extremity',
  },
  VIEW__UpperLimb: {
    image: View_of_Upper_Limb,
    darkImage: View_of_Upper_Limb_dark,
    displayName: 'View of Upper Limb',
    group: 'LIMB',
    family: 'Upper Extremity',
  },

  // Facial Views
  VIEW__Orbits: {
    image: Orbits_View,
    darkImage: Orbits_View_dark,
    displayName: 'Orbits View',
    group: 'FACIAL',
    family: 'Eyes',
  },

  // Femur Views
  VIEW__Femoral: {
    image: Femur_Plane,
    darkImage: Femur_Plane_dark,
    displayName: 'Femur Plane',
    group: 'FEMUR',
    family: 'Femur Measurement',
  },

  // Sagittal Views
  VIEW__SagittalViewOfCervixWithPlacenta: {
    image: Sagittal_View_of_Cervix_with_Placenta,
    darkImage: Sagittal_View_of_Cervix_with_Placenta_dark,
    displayName: 'Sagittal View of Cervix with Placenta',
    group: 'SAGITTAL',
    family: 'Maternal Structure',
  },
  VIEW__CrownRumpLengthView: {
    image: Sagittal_View_for_CRL_and_NC_Measurements,
    darkImage: Sagittal_View_for_CRL_and_NC_Measurements_dark,
    displayName: 'Crown Rump Length View',
    group: 'SAGITTAL',
    family: 'Biometry',
  },
  VIEW__NuchalTranslucencyViewT1: {
    image: Sagittal_View_for_CRL_and_NC_Measurements,
    darkImage: Sagittal_View_for_CRL_and_NC_Measurements_dark,
    displayName: 'Nuchal Translucency View T1',
    group: 'SAGITTAL',
    family: 'Biometry',
  },

  // Additional view
  VIEW__AmnioticFluidPocket: {
    image: afpocket,
    darkImage: afpocket_dark,
    displayName: 'Amniotic Fluid Pocket View',
    group: 'ABDOMINAL_GENITALIA',
    family: 'Abdomen',
  },
};

// View groupings configuration
export const view_groupe = {
  // Group 1: Cardiac Views
  VIEW__4CH: { group: 'CARDIAC', family: 'Heart Structure' },
  VIEW__LVOT: { group: 'CARDIAC', family: 'Heart Outflow' },
  VIEW__RVOT: { group: 'CARDIAC', family: 'Heart Outflow' },
  VIEW__ThreeVesselView: { group: 'CARDIAC', family: 'Great Vessels' },

  // Group 2: Fetal Head and Brain Views
  VIEW__Transcerebellar: {
    group: 'FETAL_HEAD_BRAIN',
    family: 'Brain Structure',
  },
  VIEW__Transventricular: {
    group: 'FETAL_HEAD_BRAIN',
    family: 'Brain Structure',
  },
  VIEW__Transthalamic: { group: 'FETAL_HEAD_BRAIN', family: 'Brain Structure' },

  // Group 3: Spinal Views
  // VIEW__SagittalViewOfTheEntireSpine: {
  //   group: 'SPINAL',
  //   family: 'Spine Structure',
  // },

  // Group 4: Abdominal and Genitalia Views
  VIEW__FetalAbdominalStandardPlane: {
    group: 'ABDOMINAL_GENITALIA',
    family: 'Abdomen',
  },

  VIEW__AmnioticFluidPocket: {
    group: 'ABDOMINAL_GENITALIA',
    family: 'Abdomen',
  },

  VIEW__OfGenitalia: { group: 'ABDOMINAL_GENITALIA', family: 'Urogenital' },

  // Group 5: Limb Views
  VIEW__UpperLimb: { group: 'LIMB', family: 'Upper Extremity' }, // Keep for backward compatibility
  VIEW__LowerLimb: { group: 'LIMB', family: 'Lower Extremity' }, // Keep for backward compatibility

  // Group 6: Renal and Bladder Views
  VIEW__AxialViewOfKidneys: { group: 'RENAL_BLADDER', family: 'Urogenital' },
  VIEW__AxialViewOfFetalBladder: {
    group: 'RENAL_BLADDER',
    family: 'Urogenital',
  },

  // Group 7: Facial Views
  VIEW__Orbits: { group: 'FACIAL', family: 'Eyes' },

  // Group 8: Femur Views
  VIEW__Femoral: { group: 'FEMUR', family: 'Femur Measurement' }, // Keep for backward compatibility

  // Group 9: Sagittal Views
  VIEW__SagittalViewOfCervixWithPlacenta: {
    group: 'SAGITTAL',
    family: 'Maternal Structure',
  },
  VIEW__CrownRumpLengthView: { group: 'SAGITTAL', family: 'Biometry' },
  VIEW__NuchalTranslucencyViewT1: { group: 'SAGITTAL', family: 'Biometry' },
};

/**
 * View codes that have measurement support (MEAS) in inference/reporting.
 * Used to show "Meas" vs "Not supported yet" badges in the grid viewer.
 * Aligned with expand_measurement_stubs plan (BATCH_INFERENCE + backend MEAS keys).
 */
export const VIEWS_WITH_MEASUREMENTS = new Set<string>([
  'VIEW__4CH',
  'VIEW__LVOT',
  'VIEW__RVOT',
  'VIEW__ThreeVesselView',
  'VIEW__Transcerebellar',
  'VIEW__Transventricular',
  'VIEW__Transthalamic',
  'VIEW__FetalAbdominalStandardPlane',
  'VIEW__AxialViewOfFetalBladder',
  'VIEW__Orbits',
  'VIEW__Femoral',
  'VIEW__AmnioticFluidPocket',
  'VIEW__UpperLimb',
  'VIEW__LowerLimb',
  'VIEW__SagittalViewOfCervixWithPlacenta',
  'VIEW__NuchalTranslucencyViewT1',
  'VIEW__CrownRumpLengthView',
]);

/** Per-view measurement keys: only these MEAS__* are shown for each view (avoids showing AC/Transversal on Bladder view). */
export const VIEW_MEASUREMENT_KEYS: Record<string, Set<string>> = {
  VIEW__AxialViewOfFetalBladder: new Set(['MEAS__BLADDER_DIAMETER']),
  VIEW__FetalAbdominalStandardPlane: new Set(['MEAS__AC', 'MEAS__TRANSVERSAL']),
  VIEW__SagittalViewOfCervixWithPlacenta: new Set(['MEAS__CERVICAL_LENGTH', 'MEAS__PLACENTAL_THICKNESS']),
  // VIEW__4CH: new Set(['MEAS__CTR', 'MEAS__LV_DIAMETER', 'MEAS__RV_DIAMETER', 'MEAS__IVS_THICKNESS', 'MEAS__MITRAL_VALVE', 'MEAS__TRICUSPID_VALVE']),
  VIEW__4CH: new Set(['MEAS__LV_DIAMETER', 'MEAS__RV_DIAMETER', 'MEAS__IVS_THICKNESS', 'MEAS__AORTA_DIAMETER']),
  VIEW__LVOT: new Set([
    'MEAS__LV_DIAMETER',
    'MEAS__AORTA_DIAMETER',
    'MEAS__RV_DIAMETER',
    'MEAS__IVS_THICKNESS',
  ]),
  VIEW__RVOT: new Set([
    'MEAS__PA_DIAMETER',
    'MEAS__RV_DIAMETER',
    'MEAS__AORTA_DIAMETER',
  ]),
  VIEW__ThreeVesselView: new Set(['MEAS__AORTA_DIAMETER']),
  VIEW__Transcerebellar: new Set(['MEAS__TCD', 'MEAS__CISTERNA_MAGNA', 'MEAS__CSP_WIDTH', 'MEAS__BPD', 'MEAS__HC']),
  VIEW__Transventricular: new Set(['MEAS__LATERAL_VENTRICLE_WIDTH', 'MEAS__CHOROID_PLEXUS', 'MEAS__CSP_WIDTH', 'MEAS__BPD', 'MEAS__HC']),
  VIEW__Transthalamic: new Set(['MEAS__CSP_WIDTH', 'MEAS__BPD', 'MEAS__HC']),
  VIEW__Orbits: new Set(['MEAS__ORBITAL_DIAMETER', 'MEAS__IOD']),
  VIEW__Femoral: new Set(['MEAS__FL']),
  VIEW__AmnioticFluidPocket: new Set(['MEAS__SDP']),
  VIEW__UpperLimb: new Set(['MEAS__HL']),
  VIEW__LowerLimb: new Set(['MEAS__FL', 'MEAS__TIBIA_LENGTH']),
  VIEW__NuchalTranslucencyViewT1: new Set(['MEAS__NT']),
  VIEW__CrownRumpLengthView: new Set(['MEAS__CRL']),
};

// Helper function to get plane config by view code
export const getPlaneConfig = (viewCode: string) => {
  return PLANES_CONFIGS[viewCode] || null;
};

// Helper function to get all available view codes
export const getAvailableViewCodes = () => {
  return Object.keys(PLANES_CONFIGS);
};

/** Numeric labels = model_category_def.id / ONNX class (see scripts/seed-data.sql). */
export const planeConfigsCriteria = {
  VIEW__4CH: {
    planeType: 'four_chamber',
    totalCount: 10,
    criteria: [
      { key: 'QUAL_FLAG__heart', title: 'Heart', label: 25 },
      { key: 'QUAL_FLAG__left_ventricle', title: 'Left Ventricle', label: 31 },
      { key: 'QUAL_FLAG__right_ventricle', title: 'Right Ventricle', label: 46 },
      { key: 'QUAL_FLAG__left_atrium', title: 'Left Atrium', label: 30 },
      { key: 'QUAL_FLAG__right_atrium', title: 'Right Atrium', label: 45 },
      { key: 'QUAL_FLAG__inter_atrial_septum', title: 'Inter Atrial Septum', label: 28 },
      { key: 'QUAL_FLAG__interventricular_septum', title: 'Interventricular Septum', label: 29 },
      { key: 'QUAL_FLAG__mitral_valve', title: 'Mitral Valve', label: 36 },
      { key: 'QUAL_FLAG__tricuspid_valve', title: 'Tricuspid Valve', label: 52 },
      { key: 'QUAL_FLAG__aorta', title: 'Aorta', label: 3 },
    ],
  },
  VIEW__LVOT: {
    planeType: 'lvot',
    totalCount: 4,
    criteria: [
      { key: 'QUAL_FLAG__heart', title: 'Heart', label: 25 },
      { key: 'QUAL_FLAG__left_ventricle', title: 'Left Ventricle', label: 31 },
      { key: 'QUAL_FLAG__right_ventricle', title: 'Right Ventricle', label: 46 },
      { key: 'QUAL_FLAG__aorta', title: 'Aorta', label: 3 },
    ],
  },
  VIEW__RVOT: {
    planeType: 'rvot',
    totalCount: 9,
    criteria: [
      { key: 'QUAL_FLAG__right_ventricle', title: 'Right Ventricle', label: 46 },
      { key: 'QUAL_FLAG__pulmonary_artery', title: 'Pulmonary Artery', label: 43 },
      { key: 'QUAL_FLAG__tricuspid_valve', title: 'Tricuspid Valve', label: 52 },
      { key: 'QUAL_FLAG__heart', title: 'Heart', label: 25 },
      { key: 'QUAL_FLAG__superior_vena_cava', title: 'Superior Vena Cava', label: 49 },
      { key: 'QUAL_FLAG__aorta', title: 'Aorta', label: 3 },
      { key: 'QUAL_FLAG__left_atrium', title: 'Left Atrium', label: 30 },
      { key: 'QUAL_FLAG__left_ventricle', title: 'Left Ventricle', label: 31 },
      { key: 'QUAL_FLAG__mitral_valve', title: 'Mitral Valve', label: 36 },
    ],
  },
  VIEW__ThreeVesselView: {
    planeType: 'three_vessel',
    totalCount: 3,
    criteria: [
      {
        key: 'QUAL_FLAG__superior_vena_cava',
        title: 'Superior Vena Cava',
        label: 49,
      },
      { key: 'QUAL_FLAG__aorta', title: 'Aorta', label: 3 },
      {
        key: 'QUAL_FLAG__pulmonary_artery',
        title: 'Pulmonary Artery',
        label: 43,
      },
    ],
  },

  VIEW__Transventricular: {
    planeType: 'transventricular',
    totalCount: 4,
    criteria: [
      { key: 'QUAL_FLAG__fetal_brain', title: 'Cephalic Plane', label: 6 },
      { key: 'QUAL_FLAG__ventricle', title: 'Ventricle', label: 55 },
      {
        key: 'QUAL_FLAG__cavum_septum_pellucidum',
        title: 'Cavum Septum Pellucidum',
        label: 5,
      },
      { key: 'QUAL_FLAG__choroid_plexus', title: 'Choroid Plexus', label: 11 },
    ],
  },
  VIEW__Transthalamic: {
    planeType: 'transthalamic',
    totalCount: 3,
    criteria: [
      { key: 'QUAL_FLAG__fetal_brain', title: 'Cephalic Plane', label: 6 },
      {
        key: 'QUAL_FLAG__cavum_septum_pellucidum',
        title: 'Cavum Septum Pellucidum',
        label: 5,
      },
      { key: 'QUAL_FLAG__thalamus', title: 'Thalamus', label: 51 },
    ],
  },
  VIEW__Transcerebellar: {
    planeType: 'transcerebellar',
    totalCount: 2,
    criteria: [
      { key: 'QUAL_FLAG__fetal_brain', title: 'Cephalic Plane', label: 6 },
      {
        key: 'QUAL_FLAG__cerebellum',
        title: 'Cerebellum',
        label: 8,
      },
    ],
  },
  // VIEW__SagittalViewOfTheEntireSpine: {
  //   planeType: 'sagittal_spine',
  //   totalCount: 1,
  //   criteria: [
  //     { key: 'QUAL_FLAG__fetal_spine', title: 'Fetal Spine', label: 8 },
  //   ],
  // },

  VIEW__FetalAbdominalStandardPlane: {
    planeType: 'abdominal',
    totalCount: 4,
    criteria: [
      {
        key: 'QUAL_FLAG__abdomen',
        title: 'Abdominal Biometry',
        label: 1,
      },
      { key: 'QUAL_FLAG__stomach_bubble', title: 'Stomach Bubble', label: 48 },
      { key: 'QUAL_FLAG__portal_sinus', title: 'Portal Sinus', label: 42 },
      {
        key: 'QUAL_FLAG__fetal_kidneys',
        title: 'Fetal Kidneys Not Visible',
        label: 16,
      },
    ],
  },

  VIEW__UpperLimb: {
    planeType: 'upper_limb',
    totalCount: 3,
    criteria: [
      {
        key: 'QUAL_FLAG__arm_humerus',
        title: 'Humerus',
        label: 4,
      },
      {
        key: 'QUAL_FLAG__forearm_bones',
        title: 'Forearm Bones',
        label: 21,
      },
      { key: 'QUAL_FLAG__hand', title: 'Hand', label: 23 },
    ],
  },
  VIEW__LowerLimb: {
    planeType: 'lower_limb',
    totalCount: 3,
    criteria: [
      { key: 'QUAL_FLAG__femur', title: 'Femur', label: 14 },
      { key: 'QUAL_FLAG__leg_bones', title: 'Leg Bones', label: 32 },
      { key: 'QUAL_FLAG__foot', title: 'Foot', label: 19 },
    ],
  },
  VIEW__AxialViewOfKidneys: {
    planeType: 'kidneys',
    totalCount: 3,
    criteria: [
      { key: 'QUAL_FLAG__fetal_kidneys', title: 'Fetal Kidneys', label: 16 },
      {
        key: 'QUAL_FLAG__stomach_bubble',
        title: 'Stomach Bubble',
        label: 48,
      },
      {
        key: 'QUAL_FLAG__portal_sinus',
        title: 'Portal Sinus',
        label: 42,
      },
    ],
  },
  VIEW__AxialViewOfFetalBladder: {
    planeType: 'bladder',
    totalCount: 1,
    criteria: [
      {
        key: 'QUAL_FLAG__fetal_bladder',
        title: 'Fetal Bladder',
        label: 15,
      },
    ],
  },

  VIEW__OfGenitalia: {
    planeType: 'genitalia',
    totalCount: 2,
    criteria: [
      { key: 'QUAL_FLAG__genitalia', title: 'Genitalia', label: 22 },
      { key: 'QUAL_FLAG__abdomen', title: 'Abdominal Biometry', label: 1 },
    ],
  },
  VIEW__Femoral: {
    planeType: 'femur',
    totalCount: 2,
    criteria: [
      { key: 'QUAL_FLAG__femur', title: 'Femur', label: 14 },
      {
        key: 'QUAL_FLAG__femur_extremity',
        title: 'Femur Extremities',
        label: 13,
      },
    ],
  },
  VIEW__SagittalViewOfCervixWithPlacenta: {
    planeType: 'sagittal_view_of_cervix_with_placenta',
    totalCount: 2,
    criteria: [
      { key: 'QUAL_FLAG__cervix', title: 'Cervix', label: 10 },
      { key: 'QUAL_FLAG__placenta', title: 'Placenta', label: 41 },
    ],
  },
  VIEW__CrownRumpLengthView: {
    planeType: 'sagittal_view_for_crl_and_nc_measurements',
    totalCount: 5,
    criteria: [
      {
        key: 'QUAL_FLAG__fetal_segmentation',
        title: 'Fetal Segmentation',
        label: 17,
      },
      {
        key: 'QUAL_FLAG__hard_palate',
        title: 'Hard Palate',
        label: 24,
      },
      {
        key: 'QUAL_FLAG__nasal_bone',
        title: 'Nasal Bone',
        label: 38,
      },
      {
        key: 'QUAL_FLAG__abdomen',
        title: 'Abdominal Biometry Not Visible',
        label: 1,
        expected_visible: false,
      },
      {
        key: 'QUAL_FLAG__fetal_brain',
        title: 'Head Circumference Not Visible',
        label: 6,
        expected_visible: false,
      },
    ],
  },
  VIEW__NuchalTranslucencyViewT1: {
    planeType: 'nuchal_translucency_view_t1',
    totalCount: 3,
    criteria: [
      {
        key: 'QUAL_FLAG__nuchal_translucency',
        title: 'Nuchal Translucency',
        label: 39,
      },
      {
        key: 'QUAL_FLAG__nasal_bone',
        title: 'Nasal Bone',
        label: 38,
      },
      {
        key: 'QUAL_FLAG__hard_palate',
        title: 'Hard Palate',
        label: 24,
      },
    ],
  },

  VIEW__AmnioticFluidPocket: {
    planeType: 'amniotic_fluid_pocket',
    totalCount: 1,
    criteria: [
      {
        key: 'QUAL_FLAG__amniotic_fluid',
        title: 'Amniotic Fluid Pocket',
        label: 2,
      },
    ],
  },
};

export const OPACITY = 1;

export const CATEGORIES = [
  {
    id: 'cephalic_plane',
    name: 'Cephalic Plane',
    color: `rgba(255, 0, 0, ${OPACITY})`,
  }, // Pure Red
  {
    id: 'cerebellum_segment_polygon',
    name: 'Cerebellum',
    color: `rgba(0, 0, 255, ${OPACITY})`,
  }, // Pure Blue
  {
    id: 'thalamus_segment',
    name: 'Thalamus',
    color: `rgba(0, 255, 0, ${OPACITY})`,
  }, // Pure Green
  {
    id: 'cavum_septum_pellucidum_segment_polygon',
    name: 'Cavum Septum Pellucidum',
    color: `rgba(255, 255, 0, ${OPACITY})`,
  }, // Pure Yellow
  {
    id: 'portal_sinus',
    name: 'Portal Sinus',
    color: `rgba(255, 0, 255, ${OPACITY})`,
  }, // Pure Magenta
  {
    id: 'abdominal_biometry_plane_ellipse',
    name: 'Abdominal Biometry',
    color: `rgba(0, 255, 255, ${OPACITY})`,
  }, // Pure Cyan
  {
    id: 'stomach_bubble',
    name: 'Stomach Bubble',
    color: `rgba(255, 128, 0, ${OPACITY})`,
  }, // Orange
  {
    id: 'stomach_bubble_segment',
    name: 'Stomach Bubble Not Visible',
    color: `rgba(128, 0, 128, ${OPACITY})`,
  }, // Purple
  {
    id: 'fetal_kidneys',
    name: 'Fetal Kidneys',
    color: `rgba(0, 128, 128, ${OPACITY})`,
  }, // Teal
  {
    id: 'fetal_kidneys_not_visible',
    name: 'Fetal Kidneys Not Visible',
    color: `rgba(128, 0, 0, ${OPACITY})`,
  }, // Maroon
  {
    id: 'fetal_two_kidneys',
    name: 'Fetal Two Kidneys',
    color: `rgba(0, 128, 0, ${OPACITY})`,
  }, // Dark Green
  {
    id: 'fetal_spine',
    name: 'Fetal Spine',
    color: `rgba(0, 0, 128, ${OPACITY})`,
  }, // Navy Blue
  {
    id: 'femur_segment',
    name: 'Femur',
    color: `rgba(255, 192, 0, ${OPACITY})`,
  }, // Gold
  {
    id: 'femur_extremities_box_segment',
    name: 'Femur Extremities',
    color: `rgba(192, 0, 192, ${OPACITY})`,
  }, // Dark Magenta
  {
    id: 'umbilical_cord',
    name: 'Umbilical Cord',
    color: `rgba(64, 224, 208, ${OPACITY})`,
  }, // Turquoise
  {
    id: 'af_pocket',
    name: 'AF Pocket',
    color: `rgba(255, 69, 0, ${OPACITY})`,
  }, // Red Orange
  {
    id: 'placenta_polygon',
    name: 'Placenta',
    color: `rgba(75, 0, 130, ${OPACITY})`,
  }, // Indigo
  {
    id: 'fourth_ventricle',
    name: 'Fourth Ventricle',
    color: `rgba(255, 20, 147, ${OPACITY})`,
  }, // Deep Pink
  {
    id: 'forearm_bones_segment_polygon',
    name: 'Forearm Bones',
    color: `rgba(0, 191, 255, ${OPACITY})`,
  }, // Deep Sky Blue
  {
    id: 'inferior_vena_cava',
    name: 'Inferior Vena Cava',
    color: `rgba(50, 205, 50, ${OPACITY})`,
  }, // Lime Green
  {
    id: 'right_ventricle',
    name: 'Right Ventricle',
    color: `rgba(220, 20, 60, ${OPACITY})`,
  }, // Crimson
  { id: 'ribs', name: 'Ribs', color: `rgba(255, 140, 0, ${OPACITY})` }, // Dark Orange
  {
    id: 'sagittal_complete_spine_with_skin_covering',
    name: 'Sagittal Complete Spine with Skin Covering',
    color: `rgba(230, 225, 150, ${OPACITY})`,
  }, // Light Khaki
  {
    id: 'adrenal_gland',
    name: 'Adrenal Gland',
    color: `rgba(144, 255, 144, ${OPACITY})`,
  }, // Light Lime Green
  {
    id: 'sylvian_fissure',
    name: 'Sylvian Fissure',
    color: `rgba(255, 200, 100, ${OPACITY})`,
  }, // Light Orange
  {
    id: 'ventricle_segment',
    name: 'Ventricle',
    color: `rgba(175, 238, 238, ${OPACITY})`,
  }, // Light Turquoise
  {
    id: 'superior_vena_cava',
    name: 'Superior Vena Cava',
    color: `rgba(176, 196, 255, ${OPACITY})`,
  }, // Light Royal Blue
  {
    id: 'diaphragm_polyline_on_sagittal_view',
    name: 'Diaphragm',
    color: `rgba(238, 180, 238, ${OPACITY})`,
  }, // Light Orchid
  {
    id: 'third_ventricle',
    name: 'Third Ventricle',
    color: `rgba(255, 160, 200, ${OPACITY})`,
  }, // Light Pink
  {
    id: 'umbilical_vein',
    name: 'Umbilical Vein',
    color: `rgba(144, 255, 180, ${OPACITY})`,
  }, // Light Spring Green
  {
    id: 'hippocampal_gyri',
    name: 'Hippocampal Gyri',
    color: `rgba(255, 200, 220, ${OPACITY})`,
  }, // Light Pink
  {
    id: 'leg_bones_segment_polygon',
    name: 'Leg Bones',
    color: `rgba(200, 220, 255, ${OPACITY})`,
  }, // Light Steel Blue
  {
    id: 'corpus_callosum_sagittal_view_segment',
    name: 'Corpus Callosum',
    color: `rgba(255, 180, 220, ${OPACITY})`,
  }, // Light Hot Pink
  {
    id: 'nostrils_box_segment',
    name: 'Nostrils',
    color: `rgba(200, 255, 150, ${OPACITY})`,
  }, // Light Green Yellow
  {
    id: 'spina_bifida',
    name: 'Spina Bifida',
    color: `rgba(255, 240, 220, ${OPACITY})`,
  }, // Light Bisque
  {
    id: 'nasal_bone',
    name: 'Nasal Bone',
    color: `rgba(175, 225, 255, ${OPACITY})`,
  }, // Light Sky Blue
  {
    id: 'hard_palate',
    name: 'Hard Palate',
    color: `rgba(255, 220, 230, ${OPACITY})`,
  }, // Light Pink
  {
    id: 'pulmonary_artery',
    name: 'Pulmonary Artery',
    color: `rgba(240, 200, 240, ${OPACITY})`,
  }, // Light Plum
  {
    id: 'right_atrium',
    name: 'Right Atrium',
    color: `rgba(200, 240, 255, ${OPACITY})`,
  }, // Light Powder Blue
  {
    id: 'orbit_segment',
    name: 'Orbits',
    color: `rgba(255, 200, 160, ${OPACITY})`,
  }, // Light Salmon
  {
    id: 'inter_atrial_septum',
    name: 'Inter Atrial Septum',
    color: `rgba(180, 255, 180, ${OPACITY})`,
  }, // Light Pale Green
  {
    id: 'umbilical_cord_insertion_on_fetal_abdomen',
    name: 'Umbilical Cord Insertion on Fetal Abdomen',
    color: `rgba(255, 180, 255, ${OPACITY})`,
  }, // Light Violet
  {
    id: 'arm_humerus_segment_polygon',
    name: 'Humerus',
    color: `rgba(255, 240, 200, ${OPACITY})`,
  }, // Light Wheat
  {
    id: 'fetal_neck',
    name: 'Fetal Neck',
    color: `rgba(255, 255, 220, ${OPACITY})`,
  }, // Light Lemon Chiffon
  { id: 'lungs', name: 'Lungs', color: `rgba(200, 255, 255, ${OPACITY})` }, // Light Turquoise
  {
    id: 'left_ventricle',
    name: 'Left Ventricle',
    color: `rgba(255, 220, 120, ${OPACITY})`,
  }, // Light Golden Rod
  {
    id: 'cerebral_peduncle',
    name: 'Cerebral Peduncle',
    color: `rgba(180, 255, 230, ${OPACITY})`,
  }, // Light Aquamarine
  {
    id: 'choroid_plexus',
    name: 'Choroid Plexus',
    color: `rgba(255, 230, 200, ${OPACITY})`,
  }, // Light Peach Puff
  {
    id: 'cisterna_magna',
    name: 'Cisterna Magna',
    color: `rgba(230, 210, 230, ${OPACITY})`,
  }, // Light Thistle
  {
    id: 'umbilical_cord_insertion_site_on_the_placenta',
    name: 'Umbilical Cord Insertion Site on the Placenta',
    color: `rgba(255, 180, 180, ${OPACITY})`,
  }, // Light Coral
  {
    id: 'fetal_bladder_segment_polygon',
    name: 'Bladder',
    color: `rgba(180, 255, 180, ${OPACITY})`,
  }, // Light Green
  {
    id: 'left_atrium',
    name: 'Left Atrium',
    color: `rgba(255, 240, 200, ${OPACITY})`,
  }, // Light Navajo White
  {
    id: 'midline_falx',
    name: 'Midline Falx',
    color: `rgba(255, 250, 230, ${OPACITY})`,
  }, // Light Antique White
  { id: 'aorta', name: 'Aorta', color: `rgba(255, 240, 240, ${OPACITY})` }, // Light Misty Rose
  {
    id: 'interventricular_septum',
    name: 'Interventricular Septum',
    color: `rgba(250, 255, 250, ${OPACITY})`,
  }, // Light Honeydew
  {
    id: 'placenta_cysts',
    name: 'Placenta Cysts',
    color: `rgba(255, 250, 240, ${OPACITY})`,
  }, // Light Old Lace
  {
    id: 'coronal_complete_spine',
    name: 'Coronal Complete Spine',
    color: `rgba(255, 245, 220, ${OPACITY})`,
  }, // Light Papaya Whip
  {
    id: 'gallbladder',
    name: 'Gallbladder',
    color: `rgba(255, 240, 200, ${OPACITY})`,
  }, // Light Moccasin
  { id: 'vermis', name: 'Vermis', color: `rgba(255, 255, 250, ${OPACITY})` }, // Light Floral White
  {
    id: 'upper_lip_segment',
    name: 'Upper Lip',
    color: `rgba(250, 255, 250, ${OPACITY})`,
  }, // Light Mint Cream
  {
    id: 'arterial_duct',
    name: 'Arterial Duct',
    color: `rgba(240, 240, 255, ${OPACITY})`,
  }, // Light Lavender
  {
    id: 'mandible',
    name: 'Mandible',
    color: `rgba(255, 250, 230, ${OPACITY})`,
  }, // Light Cornsilk
  { id: 'heart', name: 'Heart', color: `rgba(255, 250, 250, ${OPACITY})` }, // Light Lavender Blush
  {
    id: 'hepatic_vein',
    name: 'Hepatic Vein',
    color: `rgba(250, 255, 255, ${OPACITY})`,
  }, // Light Azure
  {
    id: 'nuchal_translucency',
    name: 'Nuchal Translucency',
    color: `rgba(250, 250, 255, ${OPACITY})`,
  }, // Light Ghost White
  { id: 'trachea', name: 'Trachea', color: `rgba(250, 250, 250, ${OPACITY})` }, // Light White Smoke
  {
    id: 'genitalia_segment',
    name: 'Genitalia',
    color: `rgba(150, 255, 250, ${OPACITY})`,
  }, // Light Turquoise
  {
    id: 'cervix_polygon',
    name: 'Cervix',
    color: `rgba(255, 255, 230, ${OPACITY})`,
  }, // Light Beige
  {
    id: 'lenses_cristallin_polygon',
    name: 'Lenses',
    color: `rgba(240, 240, 240, ${OPACITY})`,
  }, // Light Gainsboro
  { id: 'hand_box', name: 'Hand', color: `rgba(230, 230, 230, ${OPACITY})` }, // Light Gray
  {
    id: 'maternal_bladder',
    name: 'Maternal Bladder',
    color: `rgba(220, 220, 220, ${OPACITY})`,
  }, // Light Silver
  {
    id: 'foot',
    name: 'Foot',
    color: `rgba(255, 200, 180, ${OPACITY})`,
  }, // Light Peach
  {
    id: 'foramen_ovale',
    name: 'Foramen Ovale',
    color: `rgba(200, 180, 255, ${OPACITY})`,
  }, // Light Lavender
  {
    id: 'mitral_valve',
    name: 'Mitral Valve',
    color: `rgba(255, 180, 200, ${OPACITY})`,
  }, // Light Rose
  {
    id: 'tricuspid_valve',
    name: 'Tricuspid Valve',
    color: `rgba(180, 255, 200, ${OPACITY})`,
  }, // Light Mint
  {
    id: 'amniotic_fluid',
    name: 'Amniotic Fluid',
    color: `rgba(0, 128, 255, ${OPACITY})`,
  }, // Ocean Blue
  {
    id: 'abdomen',
    name: 'Abdomen',
    color: `rgba(0, 100, 0, ${OPACITY})`,
  }, // Dark Green
  {
    id: 'fetal_brain',
    name: 'Fetal Brain',
    color: `rgba(255, 0, 96, ${OPACITY})`,
  }, // Bright Rose Red
];

export const QUALITY_FLAGS = {
  VIEW__4CH: [
    { code: 'left_ventricle', name: 'Left Ventricle', shouldBeVisible: true },
    { code: 'right_ventricle', name: 'Right Ventricle', shouldBeVisible: true },
    { code: 'left_atrium', name: 'Left Atrium', shouldBeVisible: true },
    { code: 'right_atrium', name: 'Right Atrium', shouldBeVisible: true },
    {
      code: 'inter_atrial_septum',
      name: 'Inter Atrial Septum',
      shouldBeVisible: true,
    },
    // { code: 'mitral_valve', name: 'Mitral Valve', shouldBeVisible: true },
    // { code: 'tricuspid_valve', name: 'Tricuspid Valve', shouldBeVisible: true },
    { code: 'heart', name: 'Heart', shouldBeVisible: true },
    {
      code: 'interventricular_septum',
      name: 'Interventricular Septum',
      shouldBeVisible: true,
    },
    {
      code: 'abdomen',
      name: 'Abdominal Biometry Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'fetal_kidneys',
      name: 'Fetal Kidneys Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'stomach_bubble',
      name: 'Stomach Bubble Not Visible',
      shouldBeVisible: false,
    },
  ],
  VIEW__LVOT: [
    { code: 'heart', name: 'Heart', shouldBeVisible: true },
    { code: 'left_ventricle', name: 'Left Ventricle', shouldBeVisible: true },
    { code: 'right_ventricle', name: 'Right Ventricle', shouldBeVisible: true },
    { code: 'left_atrium', name: 'Left Atrium', shouldBeVisible: true },
    { code: 'mitral_valve', name: 'Mitral Valve', shouldBeVisible: true },
    {
      code: 'interventricular_septum',
      name: 'Interventricular Septum',
      shouldBeVisible: true,
    },
    { code: 'aorta', name: 'Aorta', shouldBeVisible: true },
    {
      code: 'right_atrium',
      name: 'Right Atrium Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'pulmonary_artery',
      name: 'Pulmonary Artery Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'tricuspid_valve',
      name: 'Tricuspid Valve Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'superior_vena_cava',
      name: 'Superior Vena Cava Not Visible',
      shouldBeVisible: false,
    },
  ],
  VIEW__RVOT: [
    { code: 'right_ventricle', name: 'Right Ventricle', shouldBeVisible: true },
    {
      code: 'pulmonary_artery',
      name: 'Pulmonary Artery',
      shouldBeVisible: true,
    },
    { code: 'tricuspid_valve', name: 'Tricuspid Valve', shouldBeVisible: true },
    { code: 'heart', name: 'Heart', shouldBeVisible: true },
    {
      code: 'superior_vena_cava',
      name: 'Superior Vena Cava',
      shouldBeVisible: true,
    },
    { code: 'aorta', name: 'Aorta', shouldBeVisible: true },
    {
      code: 'left_atrium',
      name: 'Left Atrium Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'left_ventricle',
      name: 'Left Ventricle Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'mitral_valve',
      name: 'Mitral Valve Not Visible',
      shouldBeVisible: false,
    },
  ],
  VIEW__ThreeVesselView: [
    {
      code: 'superior_vena_cava',
      name: 'Superior Vena Cava',
      shouldBeVisible: true,
    },
    { code: 'aorta', name: 'Aorta', shouldBeVisible: true },
    {
      code: 'pulmonary_artery',
      name: 'Pulmonary Artery',
      shouldBeVisible: true,
    },
    {
      code: 'left_ventricle',
      name: 'Left Ventricle Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'right_ventricle',
      name: 'Right Ventricle Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'left_atrium',
      name: 'Left Atrium Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'right_atrium',
      name: 'Right Atrium Not Visible',
      shouldBeVisible: false,
    },
  ],
  VIEW__Transcerebellar: [
    { code: 'thalamus', name: 'Thalamus', shouldBeVisible: true },
    { code: 'vermis', name: 'Vermis', shouldBeVisible: true },
    { code: 'cerebellum', name: 'Cerebellum', shouldBeVisible: true },
    { code: 'cisterna_magna', name: 'Cisterna Magna', shouldBeVisible: true },
    {
      code: 'cavum_septum_pellucidum',
      name: 'Cavum Septum Pellucidum',
      shouldBeVisible: true,
    },
    { code: 'fetal_brain', name: 'Cephalic Plane', shouldBeVisible: true },
  ],
  VIEW__Transventricular: [
    { code: 'ventricle', name: 'Ventricle', shouldBeVisible: true },
    { code: 'choroid_plexus', name: 'Choroid Plexus', shouldBeVisible: true },
    {
      code: 'cavum_septum_pellucidum',
      name: 'Cavum Septum Pellucidum',
      shouldBeVisible: true,
    },
    { code: 'fetal_brain', name: 'Cephalic Plane', shouldBeVisible: true },
    { code: 'thalamus', name: 'Thalamus Not Visible', shouldBeVisible: false },
    {
      code: 'cerebellum',
      name: 'Cerebellum Not Visible',
      shouldBeVisible: false,
    },
    { code: 'vermis', name: 'Vermis Not Visible', shouldBeVisible: false },
  ],
  VIEW__Transthalamic: [
    {
      code: 'cavum_septum_pellucidum',
      name: 'Cavum Septum Pellucidum',
      shouldBeVisible: true,
    },
    { code: 'thalamus', name: 'Thalamus', shouldBeVisible: true },
    {
      code: 'hippocampal_gyri',
      name: 'Hippocampal Gyri',
      shouldBeVisible: true,
    },
    { code: 'fetal_brain', name: 'Cephalic Plane', shouldBeVisible: true },
    { code: 'sylvian_fissure', name: 'Sylvian Fissure', shouldBeVisible: true },
    {
      code: 'cerebellum',
      name: 'Cerebellum Not Visible',
      shouldBeVisible: false,
    },
    { code: 'vermis', name: 'Vermis Not Visible', shouldBeVisible: false },
    {
      code: 'cisterna_magna',
      name: 'Cisterna Magna Not Visible',
      shouldBeVisible: false,
    },
  ],
  VIEW__FetalAbdominalStandardPlane: [
    { code: 'abdomen', name: 'Abdominal Biometry', shouldBeVisible: true },
    { code: 'stomach_bubble', name: 'Stomach Bubble', shouldBeVisible: true },
    { code: 'portal_sinus', name: 'Portal Sinus', shouldBeVisible: true },
    {
      code: 'fetal_kidneys',
      name: 'Fetal Kidneys Not Visible',
      shouldBeVisible: false,
    },
    { code: 'lungs', name: 'Lungs Not Visible', shouldBeVisible: false },
    { code: 'heart', name: 'Heart Not Visible', shouldBeVisible: false },
    {
      code: 'left_ventricle',
      name: 'Left Ventricle Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'right_ventricle',
      name: 'Right Ventricle Not Visible',
      shouldBeVisible: false,
    },
  ],
  VIEW__UpperLimb: [
    { code: 'arm_humerus', name: 'Arm Humerus', shouldBeVisible: true },
    { code: 'forearm_bones', name: 'Forearm Bones', shouldBeVisible: true },
    { code: 'hand', name: 'Hand', shouldBeVisible: true },
    { code: 'femur', name: 'Femur Not Visible', shouldBeVisible: false },
    {
      code: 'leg_bones',
      name: 'Leg Bones Not Visible',
      shouldBeVisible: false,
    },
    { code: 'foot', name: 'Foot Not Visible', shouldBeVisible: false },
  ],
  VIEW__LowerLimb: [
    { code: 'femur', name: 'Femur', shouldBeVisible: true },
    { code: 'leg_bones', name: 'Leg Bones', shouldBeVisible: true },
    { code: 'foot', name: 'Foot', shouldBeVisible: true },
    {
      code: 'arm_humerus',
      name: 'Arm Humerus Not Visible',
      shouldBeVisible: false,
    },
    {
      code: 'forearm_bones',
      name: 'Forearm Bones Not Visible',
      shouldBeVisible: false,
    },
    { code: 'hand', name: 'Hand Not Visible', shouldBeVisible: false },
  ],
  VIEW__AxialViewOfKidneys: [
    { code: 'fetal_kidneys', name: 'Fetal Kidneys', shouldBeVisible: true },
    { code: 'stomach_bubble', name: 'Stomach Bubble', shouldBeVisible: false },
    { code: 'portal_sinus', name: 'Portal Sinus', shouldBeVisible: false },
    { code: 'lungs', name: 'Lungs', shouldBeVisible: false },
    { code: 'fetal_bladder', name: 'Fetal Bladder', shouldBeVisible: false },
  ],
  VIEW__AxialViewOfFetalBladder: [
    { code: 'fetal_bladder', name: 'Fetal Bladder', shouldBeVisible: true },
    { code: 'lungs', name: 'Lungs', shouldBeVisible: false },
    { code: 'heart', name: 'Heart', shouldBeVisible: false },
    { code: 'stomach_bubble', name: 'Stomach Bubble', shouldBeVisible: false },
    { code: 'abdomen', name: 'Abdominal Biometry', shouldBeVisible: false },
  ],
  VIEW__Femoral: [
    {
      code: 'femur_extremity',
      name: 'Femur Extremities',
      shouldBeVisible: true,
    },
    { code: 'femur', name: 'Femur', shouldBeVisible: true },
  ],
  VIEW__CrownRumpLengthView: [
    { code: 'fetal_segmentation', name: 'Fetal Segmentation', shouldBeVisible: true },
    { code: 'hard_palate', name: 'Hard Palate', shouldBeVisible: true },
    { code: 'nasal_bone', name: 'Nasal Bone', shouldBeVisible: true },
    { code: 'abdomen', name: 'Abdominal Biometry Not Visible', shouldBeVisible: false },
    { code: 'fetal_brain', name: 'Head Circumference Not Visible', shouldBeVisible: false },
  ],
  VIEW__NuchalTranslucencyViewT1: [
    { code: 'fetal_brain', name: 'Nuchal Translucency', shouldBeVisible: true },
    { code: 'nasal_bone', name: 'Nasal Bone', shouldBeVisible: true },
    { code: 'hard_palate', name: 'Hard Palate', shouldBeVisible: true },
    {
      code: 'abdomen',
      name: 'Abdominal Biometry Not Visible',
      shouldBeVisible: false,
    },
  ],
  VIEW__Orbits: [
    { code: 'orbit', name: 'Orbits', shouldBeVisible: true },
    {
      code: 'ventricle',
      name: 'Ventricle Not Visible',
      shouldBeVisible: false,
    },
    { code: 'mandible', name: 'Mandible Not Visible', shouldBeVisible: false },
    {
      code: 'fetal_spine',
      name: 'Fetal Spine Not Visible',
      shouldBeVisible: false,
    },
  ],
  VIEW__SagittalViewOfCervixWithPlacenta: [
    { code: 'cervix', name: 'Cervix', shouldBeVisible: true },
    {
      code: 'maternal_bladder',
      name: 'Maternal Bladder',
      shouldBeVisible: true,
    },
    { code: 'placenta', name: 'Placenta', shouldBeVisible: true },
  ],
  // VIEW__SagittalViewOfTheEntireSpine: [
  //   { code: 'fetal_spine', name: 'Fetal Spine', shouldBeVisible: true },
  //   {
  //     code: 'abdomen',
  //     name: 'Abdominal Biometry Not Visible',
  //     shouldBeVisible: false,
  //   },
  //   { code: 'heart', name: 'Heart Not Visible', shouldBeVisible: false },
  //   {
  //     code: 'fetal_brain',
  //     name: 'Cephalic Plane Not Visible',
  //     shouldBeVisible: false,
  //   },
  // ],
  VIEW__AmnioticFluidPocket: [
    { code: 'amniotic_fluid', name: 'Amniotic Fluid', shouldBeVisible: true },
  ],
};
